import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,[_c('TableOrdersB2B')],1),_c(VCol,[_c('TableServiceCenter')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }